import { useTranslation } from 'react-i18next';
import { useOnline } from '../lib/hooks';
import { Icon } from '../ui';
import styles from './layout.module.css';

/** Honest offline notice: cached lists stay readable; changes wait for the connection. */
export function OfflineBanner() {
  const online = useOnline();
  const { t } = useTranslation();
  if (online) return null;
  return (
    <div className={styles.offline} role="status">
      <Icon name="offline" size={18} />
      {t('pwa.offline')}
    </div>
  );
}
